// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-view-common-data__attribute{display:flex;justify-content:space-between;width:100%}.ac-view-common-data__label{font-family:\"Montserrat\";text-transform:uppercase;white-space:pre}.ac-view-common-data__label--tall{margin-bottom:1rem}.ac-view-common-data__list-item{padding:1.5rem 2rem}\n", ""]);
// Exports
module.exports = exports;
